import { jsx as _jsx } from "react/jsx-runtime";
import Icon from '../../../../icon';
import { DateInputCalendarTrigger } from '../styles';
export const Trigger = ({ colorContext, disabled = false, onClick }) => {
    return (_jsx(DateInputCalendarTrigger, { "data-ignore-outside-click": "true", type: "button", disabled: disabled, "$colorContext": colorContext, onClick: onClick, children: _jsx(Icon, { variant: "calendar", size: "lg" }) }));
};
